/**
 * 工具函数集合：提供通用的辅助函数。
 */

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * 合并 CSS 类名，支持条件类名和 Tailwind 类名去重
 * @param inputs - 要合并的类名值（字符串、对象、数组等）
 * @returns 合并后的类名字符串
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
